import {useMutableFn} from './useMutableFn';

type Unbox<T> = () => T;

/**
 * A hook that takes a value that may change on every render, and returns a
 * function that unboxes the current value. This is useful when you want to
 * pass a value to an event handler or other callback without regenerating that
 * event handler or callback on every render.
 *
 * @param value
 */
export function useMutableBox<T>(value: T): Unbox<T> {
  return useMutableFn(() => value);
}
